import { useState } from "react";
import { schoolsAPI } from "../features/schools/schoolsAPI";
import { reviewsAPI } from "../features/reviews/reviewsAPI";

export const useSchools = () => {
  const [schools, setSchools] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchSchools = async (params = {}) => {
    setLoading(true);
    setError(null);

    try {
      const result = await schoolsAPI.getSchools(params);

      if (result.success) {
        setSchools(result.data.schools);
        return result.data;
      } else {
        setError(result.error);
        return { success: false, error: result.error };
      }
    } catch (err) {
      const errorMessage = "Đã xảy ra lỗi không mong muốn";
      setError(errorMessage);
      return { success: false, error: errorMessage };
    } finally {
      setLoading(false);
    }
  };

  const getSchool = async (id) => {
    setLoading(true);
    setError(null);

    try {
      const result = await schoolsAPI.getSchool(id);

      if (result.success) {
        return result.data;
      } else {
        setError(result.error);
        return { success: false, error: result.error };
      }
    } catch (err) {
      const errorMessage = "Đã xảy ra lỗi không mong muốn";
      setError(errorMessage);
      return { success: false, error: errorMessage };
    } finally {
      setLoading(false);
    }
  };

  const createSchool = async (schoolData) => {
    setLoading(true);
    setError(null);

    try {
      const result = await schoolsAPI.createSchool(schoolData);

      if (result.success) {
        return result.data;
      } else {
        setError(result.error);
        return { success: false, error: result.error };
      }
    } catch (err) {
      const errorMessage = "Đã xảy ra lỗi không mong muốn";
      setError(errorMessage);
      return { success: false, error: errorMessage };
    } finally {
      setLoading(false);
    }
  };

  // Admin functions
  const getPendingSchools = async () => {
    setLoading(true);
    setError(null);

    try {
      const result = await schoolsAPI.getPendingSchools();

      if (result.success) {
        return result.data;
      } else {
        setError(result.error);
        return { success: false, error: result.error };
      }
    } catch (err) {
      const errorMessage = "Đã xảy ra lỗi không mong muốn";
      setError(errorMessage);
      return { success: false, error: errorMessage };
    } finally {
      setLoading(false);
    }
  };

  const approveSchool = async (id) => {
    setLoading(true);
    setError(null);

    try {
      const result = await schoolsAPI.approveSchool(id);

      if (result.success) {
        return result.data;
      } else {
        setError(result.error);
        return { success: false, error: result.error };
      }
    } catch (err) {
      const errorMessage = "Đã xảy ra lỗi không mong muốn";
      setError(errorMessage);
      return { success: false, error: errorMessage };
    } finally {
      setLoading(false);
    }
  };

  const rejectSchool = async (id, reason) => {
    setLoading(true);
    setError(null);

    try {
      const result = await schoolsAPI.rejectSchool(id, reason);

      if (result.success) {
        return result.data;
      } else {
        setError(result.error);
        return { success: false, error: result.error };
      }
    } catch (err) {
      const errorMessage = "Đã xảy ra lỗi không mong muốn";
      setError(errorMessage);
      return { success: false, error: errorMessage };
    } finally {
      setLoading(false);
    }
  };

  const getMySchools = async (status) => {
    setLoading(true);
    setError(null);

    try {
      const result = await schoolsAPI.getMySchools(status);

      if (result.success) {
        return result.data;
      } else {
        setError(result.error);
        return { success: false, error: result.error };
      }
    } catch (err) {
      const errorMessage = "Đã xảy ra lỗi không mong muốn";
      setError(errorMessage);
      return { success: false, error: errorMessage };
    } finally {
      setLoading(false);
    }
  };

  return {
    schools,
    loading,
    error,
    fetchSchools,
    getSchool,
    createSchool,
    getPendingSchools,
    approveSchool,
    rejectSchool,
    getMySchools,
  };
};

export const useReviews = () => {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchReviews = async (params = {}) => {
    setLoading(true);
    setError(null);

    try {
      const result = await reviewsAPI.getReviews(params);

      if (result.success) {
        setReviews(result.data.reviews);
        return result.data;
      } else {
        setError(result.error);
        return { success: false, error: result.error };
      }
    } catch (err) {
      const errorMessage = "Đã xảy ra lỗi không mong muốn";
      setError(errorMessage);
      return { success: false, error: errorMessage };
    } finally {
      setLoading(false);
    }
  };

  const getReview = async (id) => {
    setLoading(true);
    setError(null);

    try {
      const result = await reviewsAPI.getReview(id);

      if (result.success) {
        return result.data;
      } else {
        setError(result.error);
        return { success: false, error: result.error };
      }
    } catch (err) {
      const errorMessage = "Đã xảy ra lỗi không mong muốn";
      setError(errorMessage);
      return { success: false, error: errorMessage };
    } finally {
      setLoading(false);
    }
  };

  const createReview = async (reviewData) => {
    setLoading(true);
    setError(null);

    try {
      const result = await reviewsAPI.createReview(reviewData);

      if (result.success) {
        return result.data;
      } else {
        setError(result.error);
        return { success: false, error: result.error };
      }
    } catch (err) {
      const errorMessage = "Đã xảy ra lỗi không mong muốn";
      setError(errorMessage);
      return { success: false, error: errorMessage };
    } finally {
      setLoading(false);
    }
  };

  const markHelpful = async (id, helpful) => {
    setLoading(true);
    setError(null);

    try {
      const result = await reviewsAPI.markHelpful(id, helpful);

      if (result.success) {
        return result.data;
      } else {
        setError(result.error);
        return { success: false, error: result.error };
      }
    } catch (err) {
      const errorMessage = "Đã xảy ra lỗi không mong muốn";
      setError(errorMessage);
      return { success: false, error: errorMessage };
    } finally {
      setLoading(false);
    }
  };

  return {
    reviews,
    loading,
    error,
    fetchReviews,
    getReview,
    createReview,
    markHelpful,
  };
};
